module.exports = __webpack_public_path__ + "static/media/printcopy.e726e2cd.svg";